import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { ServiceProviderService } from '../../../../Service/Service-providers/service-provider.service';
import { UserService } from '../../../../Service/User/user.service';
import { UserFormStateService } from '../../Service/formStateService';

@Component({
  selector: 'app-user-personal-detail',
  templateUrl: './user-personal-detail.component.html',
  styleUrls: ['./user-personal-detail.component.scss'],
})
export class UserPersonalDetailComponent implements OnInit {
  form = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];

  countryId: any;
  countryName!: string;
  @Output() nextSection = new EventEmitter<void>();
  @Output() formValidity = new EventEmitter<boolean>();
  receivedObject: any;
  customerId: any;
  stateId: any

  constructor(
    private api: ServiceProviderService,
    private formStateService: UserFormStateService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.loadFormData();

    const userDetailsString = localStorage.getItem('user');
    if (userDetailsString) {
      const userDetails = JSON.parse(userDetailsString);
      this.countryId = userDetails.country?.countryId;
      const storedCountryName = userDetails.country?.name;
      if (this.countryId) {
        console.log(this.countryId);
        this.model.countryId = this.countryId;
        this.form.patchValue({ countryId: this.countryId });
        this.initializeField();
      }
    }
    this.initializeField();

  }

  ngOnDestroy() {
    this.saveFormData();
  }
  resetForm() {
    this.form.reset();
    this.model = {};
  }
  saveFormData() {
    const formData = { ...this.form.value };
    this.formStateService.setFormData('personal-details', formData);
    console.log(formData);
  }

  loadFormData() {
    const savedData = this.formStateService.getFormData('personal-details');
    if (savedData) {
      console.log('Saved Data:', savedData);
      this.model = savedData;
      this.form.patchValue(savedData);
    }

    const mapLocationData = this.formStateService.getFormData('map-location');
  if (mapLocationData?.address) {
    this.model.address = mapLocationData.address;
    this.form.patchValue({ address: mapLocationData.address });
  }
  }

  initializeField() {
    this.fields = [
      {
        template: '<div class="text-base font-semibold mb-4">Basics</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-4',
            key: 'name',
            type: 'input',
            templateOptions: {
              label: 'Name of the Customer',
              placeholder: 'Enter Name',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              validation: [Validators.required, Validators.minLength(3)],
            },
            validation: {
              messages: {
                required: 'Name is required',
                minlength: 'Name should be at least 3 characters long',
              },
            },
          },
          {
            className: 'field col-3',
            key: 'phone',
            type: 'input',
            templateOptions: {
              label: 'Phone Number',
              placeholder: '+91 1234567890',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              validation: [Validators.required, Validators.pattern(/^\d{10}$/)],
            },
            validation: {
              messages: {
                required: 'Phone number is required',
                pattern: 'Phone number must be exactly 10 digits',
              },
            },
          },
          {
            className: 'field col-3',
            key: 'email',
            type: 'input',
            templateOptions: {
              label: 'Email',
              placeholder: 'Enter Email Address',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              validation: [Validators.required, Validators.email],
            },
            validation: {
              messages: {
                required: 'Email is required',
                email: 'Invalid email format',
              },
            },
          },
        ],
      },
      {
        template:
          '<div class="text-base font-semibold mb-4 mt-5">Address</div>',
      },
      {
        fieldGroupClassName: 'field grid p-fluid',
        fieldGroup: [
          {
            className: 'field col-4',
            key: 'countryId',
            type: 'select',
            templateOptions: {
              disabled: true,
              options: this.api.getCountry(''),
              placeholder: 'Select a Country',
              valueProp: 'countryId',
              labelProp: 'name',
              label: 'Country',
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'Country is required',
              },
            },
            defaultValue: this.countryName,
            hooks: {
              onInit: (field) => {
                if (this.countryName) {
                  field.formControl?.setValue(this.model.countryId);
                }
              },
            },
          },
          {
            className: 'field col-3',
            key: 'stateId',
            type: 'select',
            templateOptions: {
              placeholder: 'Select State',
              options: [],
              valueProp: 'stateId',
              labelProp: 'name',
              label: 'State',
              required: true,
              hideRequiredMarker: true,
            },
            hooks: {
              onInit: (field) => {
                // Fetch states when initializing
                this.api.getStatesByCountry(this.countryId).subscribe(states => {
                  field.templateOptions!.options = states;
                });

                // Set a listener for value changes
                field.formControl?.valueChanges.subscribe((selectedStateId: number) => {
                  this.stateId = selectedStateId;

                  // Now fetch districts using selected stateId
                  const districtField = this.findFieldByKey(this.fields, 'districtId');
                  if (districtField) {
                    this.api.getDistrictsByStates(selectedStateId).subscribe(districts => {
                      districtField.templateOptions!.options = districts;
                      this.cdr.markForCheck();
                    });
                  }
                });
              }
            }
          },
          {
            className: 'field col-3',
            key: 'city',
            type: 'input',
            templateOptions: {
              label: 'City',
              placeholder: 'Select City',
              required: true,
              hideRequiredMarker: true,
            },
            validation: {
              messages: {
                required: 'City is required',
              },
            },
          },
          {
            className: 'field col-5 mt-3',
            key: 'address',
            type: 'input',
            templateOptions: {
              label: 'Address',
              placeholder: 'Enter Address',
              required: true,
              hideRequiredMarker: true,
              disabled: true,
            },
            validation: {
              messages: {
                required: 'Address is required',
              },
            },
          },
          {
            className: 'field col-5 mt-3',
            key: 'zip',
            type: 'input',
            templateOptions: {
              label: 'Pincode',
              placeholder: 'Enter Pincode',
              required: true,
              hideRequiredMarker: true,
            },
            validators: {
              validation: [Validators.required, Validators.pattern(/^\d{6}$/)],
            },
            validation: {
              messages: {
                required: 'Pincode is required',
                pattern: 'Pincode must be exactly 6 digits',
              },
            },
          },
          {
            className: 'field col-5',
            key: 'districtId',
            type: 'select',
            templateOptions: {
              placeholder: 'Select district',
              options: [], // Leave empty initially
              valueProp: 'districtId',
              labelProp: 'name',
              label: 'District',
              required: true,
              hideRequiredMarker: true,
            },
          }
          ,
        ],
      },
    ];
  }
  findFieldByKey(
    fields: FormlyFieldConfig[],
    key: string
  ): FormlyFieldConfig | null {
    for (const field of fields) {
      if (field.key === key) {
        return field;
      }
      if (field.fieldGroup && field.fieldGroup.length > 0) {
        const nestedField = this.findFieldByKey(
          field.fieldGroup as FormlyFieldConfig[],
          key
        );
        if (nestedField) {
          return nestedField;
        }
      }
    }
    return null;
  }
  populateFormWithServiceSeekersDetails(res: any) {
    const mapLocationData = this.formStateService.getFormData('map-location');
  const address = mapLocationData?.address || res.address || '';

    this.customerId = res.customerId;
    this.model.name = res?.name || '';
    this.model.phone = res?.phoneNumber || '';
    this.model.email = res?.emailAddress || '';
    this.model.address = address;
    this.model.stateId = res?.state?.stateId || '';
    this.model.countryId = this.countryId;
    this.model.city = res?.city || '';
    this.model.zip = res?.zip || '';

    // First patch everything except districtId
    this.form.patchValue({
      ...this.model,
      districtId: null, // temporarily skip districtId
    });

    // Load districts based on selected stateId
    if (this.model.stateId) {
      this.api.getDistrictsByStates(this.model.stateId).subscribe((districts: any[]) => {
        const districtField = this.findFieldByKey(this.fields, 'districtId');
        if (districtField) {
          districtField.templateOptions!.options = districts;

          // Now patch districtId after options are available
          const patchedDistrictId = res?.district?.districtId || '';
          this.model.districtId = patchedDistrictId;
          this.form.patchValue({ districtId: patchedDistrictId });

          console.log('District options loaded and districtId patched:', patchedDistrictId);
          this.cdr.detectChanges();
        }
      });
    }

    this.formStateService.setFormData('personal-details', this.model);
    this.initializeField();
  }

  onSubmit() {
    if (this.form.valid) {
      const transformedData = this.transformFormData(this.form.value);
      this.formStateService.setPersonalDetails(transformedData);
      console.log('Transformed data', transformedData);
      this.nextSection.emit();
    }
  }

  transformFormData(formData: any): any {
    const mapLocationData = this.formStateService.getFormData('map-location');
    const address = formData.address || mapLocationData?.address || '';
    const transformedData: any = {
      name: formData.name,
      phoneNumber: formData.phone,
      emailAddress: formData.email,
      address: address,
      stateId: formData.stateId,
      countryId: this.countryId,
      city: formData.city,
      zip: formData.zip,
      districtId: formData.districtId
    }
    if (this.customerId) {
      transformedData.customerId = this.customerId;
    }
    return transformedData;
  }



}
